// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__sMs8I","paramInput":"JobSimulator_paramInput__3538C","input":"JobSimulator_input__1kUtH"};